@if (anyRows()) {
    <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        [rowData]="rowData"
        [columnDefs]="columnDefs"
        [enableCellTextSelection]="true"
        [statusBar]="statusBar"
        (firstDataRendered)="onFirstDataRendered($event)"
        (sortChanged)="onSortChanged($event)"
        (filterChanged)="onFilterChanged($event)"
    />
} @else {
    <div class="subtitle">{{ 'grid.noRows' | translate }}</div>
}
